__turbopack_context__.v({
  "link": "styles-module__AGNX9W__link",
  "selected-link": "styles-module__AGNX9W__selected-link",
});
